import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { stripFroalaWatermark } from '../../../common/utils/froala.utils';
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { Subscription } from "rxjs";
import { map } from "rxjs/operators";
import { SidePanelBase } from "../../../common/components/side-panel-base.class";
import { ApplicationNotesService } from "../../services/application-notes.service";
import { WorkflowNote } from "../../models/applications.models";
import { NoteType } from "../../../common/models/note-type.enum";
import { SidePanelService } from "../../../common/services/side-panel.service";
import { Option } from "../../../common/models/flow.dto";
import { AuthService } from "../../../services/auth.service";
import { Note, objectIsArray } from '../../../common/models/note.model';
import { genId } from '../../../core/services/genId';


@Component({
    selector: 'app-application-notes',
    templateUrl: './application-notes.component.html',
    styleUrls: ['./application-notes.component.scss', '../../../common/components/notes/notes.component.scss'],
    standalone: false
})
export class ApplicationNotesComponent extends SidePanelBase implements OnInit, OnDestroy {
    static componentName = 'ApplicationNotesComponent';

    get activeNote(): WorkflowNote {
        return this.notesService.activeNote;
    }

    get isInternal(): boolean {
        return this.auth.User.isInternal;
    }

   public replyText: string;

    public buildChildNote(parent: WorkflowNote): WorkflowNote {
        const id = genId();
        return {
            id: id,
            text: "",
            createdDate: new Date,
            createdBy: this.auth.User.displayName,
            createdById: this.auth.User.id,
            noteTypeId: parent.noteTypeId,
            notePriorityId: parent.notePriorityId,
            parentNoteId: parent.id,
            workflowId: parent.workflowId,
            isDeleted: false,
            fieldId: parent.fieldId,
            retentionPolicyId: parent.retentionPolicyId,
            retentionPolicyName: parent.retentionPolicyName
        } as WorkflowNote
    }



    _displayedNotes: WorkflowNote[] = [];

    get displayed(): WorkflowNote[] {
        return this._displayedNotes;
    }  

    form: FormGroup;

    private _froalaOptions: any = null;
    get froalaOptions(): any {
        if (!this._froalaOptions) {
            let conf = window["PdfConfig"] as any;
            let key = (conf != null) ? conf.editorLicenseKey : "";
            this._froalaOptions = {
                heightMax: 300,
                height: 300,
                heightMin: 150,
                key: key,
                typingTimer: 150,
                saveInterval: 0,
                toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough']
            };
        }
        return this._froalaOptions;
    };

    private _replyFroalaOptions: any = null;
    get replyFroalaOptions(): any {
        if (!this._replyFroalaOptions) {
            this._replyFroalaOptions = {
                heightMax: 300,
                heightMin: 150,
                key: this.editorKey,
                saveInterval: 0,
                toolbarButtons: ['bold', 'italic', 'underline', 'strikeThrough'],
                typingTimer: 150,
                autofocus: true
            };
        }
        return this._replyFroalaOptions;
    }

    noteType = NoteType;
    subscription: Subscription = new Subscription();

  

    types: Option[] =  //["General", "Internal", "Administrative"];
        [
            {
                id: "-1",
                idNumeric: -1,
                text: "Select note type"
            } as Option,
            {
                id: NoteType.General.toString(),
                idNumeric: NoteType.General,
                text: "General"
            } as Option,
            {
                id: NoteType.Internal.toString(),
                idNumeric: NoteType.Internal,
                text: "Internal"
            } as Option,
            {
                id: NoteType.Administrative.toString(),
                idNumeric: NoteType.Administrative,
                text: "Administrative"
            } as Option,
        ]

    constructor(private notesService: ApplicationNotesService, private sidePanelService: SidePanelService, private auth: AuthService, public detector: ChangeDetectorRef) { super(); }

    ngOnInit() {
        if (this.auth.User.isInternal == false) {
            this.types = this.types.filter(t => t.idNumeric != NoteType.Internal && t.idNumeric != NoteType.Administrative);
        }

        const visible$ = this.notesService.visibleNotes.pipe(
            map((notes: WorkflowNote[]) => {
                if (this.auth.User.isInternal) return notes.filter(n => n.noteTypeId != NoteType.Administrative || n.createdById == this.auth.User.id);
                else return notes.filter(n => n.noteTypeId != NoteType.Administrative && n.noteTypeId != NoteType.Internal);         
            })
        ).subscribe(
            (notes: WorkflowNote[]) => {
                this._displayedNotes = notes;
            },
            (error) => { console.error(error); }
        );
        this.subscription.add(visible$);
        this.initializeForm();
    }


    ngOnDestroy() {
        if (this.subscription != null) this.subscription.unsubscribe();
    }

    cancel(): void {
        this.notesService.cancelNote();
        this.sidePanelService.toggleSidePanel(false);
    }

    isArray(obj): boolean {
        return objectIsArray(obj);
    }

    displayExpander(obj) {
        if (this.isArray(obj) && obj.length > 0)
            return true;

        return false;
    }

    initializeForm(): void {
        let formControls = {
            selectedNoteType: new FormControl(-1, [Validators.required, Validators.min(0)]),
            noteText: new FormControl('', [Validators.required])
        };

        this.form = new FormGroup(formControls);
    }

    replyForm: any;
    openReplyForm(form: any): void {
        form.isReplying = true;
        form.replyText = '';
        form.opened = true;
        this.replyForm = form;
        this.detector.detectChanges();
    }

    reply(parentNote: WorkflowNote, form: any): void {
        
        if (this.validateReply()) {
            const reply = this.buildChildNote(parentNote);
            reply.text = stripFroalaWatermark(this.replyForm.replyText);

            form.opened = true;
            parentNote.childNotes.push(reply);

            this.notesService.saveReply(reply);
         

            this.resetReplyForm(form);


        } else {
            this.detector.detectChanges();
        }

    }

 


    resetReplyForm(form: any): void {
        form.replyText = '';
        form.opened = true;
        form.isReplying = false;
        form.isDirty = false
        this.replyText = "";
        this.detector.detectChanges();
    }

    save(): void {
        if (this.activeNote.childNotes == null) {
        this.activeNote.childNotes = [];
        }
        this.activeNote.text = stripFroalaWatermark(this.form.get('noteText').value);
        this.activeNote.noteTypeId = parseInt(this.form.get('selectedNoteType').value, 10);
        this.notesService.saveNote();
        this.form.reset();
        this.form.get('selectedNoteType').setValue(-1);
        this.sidePanelService.toggleSidePanel(false);        
    }

    toggleReply(replyForm: any) {
        replyForm.opened = !replyForm.opened;
        this.detector.detectChanges();
    }

    validateReply(): boolean {
        this.replyForm.isDirty = true;
        this.detector.detectChanges();
        if (this.replyForm && this.replyForm.replyText && this.replyForm.replyText.length > 0) {
            this.replyText = this.replyForm.replyText;
            return true;
        }
        return false;
    }
}
